(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sub-collections"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.collection-pills-wrapper').forEach(function(wrapper) {
      var scroller = wrapper.querySelector('.collection-sub-collections-pills');
      var btnPrev = wrapper.querySelector('.collection-pills-arrow--prev');
      var btnNext = wrapper.querySelector('.collection-pills-arrow--next');

      function updateArrows() {
        btnPrev.hidden = scroller.scrollLeft <= 4;
        btnNext.hidden = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
      }

      btnPrev.addEventListener('click', function() {
        scroller.scrollLeft -= 200;
      });

      btnNext.addEventListener('click', function() {
        scroller.scrollLeft += 200;
      });

      scroller.addEventListener('scroll', updateArrows);
      updateArrows();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var currentId = 'wm-panel-root';
    var backBtn, backLabel;

    function getPanel(id) {
      return document.getElementById(id);
    }

    function navigate(targetId, isBack) {
      if (targetId === currentId) return;
      var prevPanel = getPanel(currentId);
      var nextPanel = getPanel(targetId);
      if (!nextPanel) return;

      if (isBack) {
        // Current slides out to the right, previous comes back to center
        if (prevPanel) delete prevPanel.dataset.state;
        nextPanel.dataset.state = 'active';
      } else {
        // Current recedes behind, new panel slides in from the right
        if (prevPanel) prevPanel.dataset.state = 'prev';
        nextPanel.dataset.state = 'active';
      }

      // Update back button
      if (nextPanel.dataset.parent) {
        backLabel.textContent = nextPanel.dataset.parentTitle || 'Retour';
        backBtn.hidden = false;
        nextPanel.scrollTop = 0;
      } else {
        backBtn.hidden = true;
      }
      currentId = targetId;
    }

    function resetToRoot() {
      // Instantly reset all panels without animation
      var allPanels = document.querySelectorAll('#dynamic-menu-drawer .wm-nav__panel');
      allPanels.forEach(function (p) {
        p.style.transition = 'none';
        if (p.id === 'wm-panel-root') {
          p.dataset.state = 'active';
        } else {
          delete p.dataset.state;
        }
      });
      // Re-enable transitions after reset
      setTimeout(function () {
        allPanels.forEach(function (p) { p.style.transition = ''; });
      }, 50);
      backBtn.hidden = true;
      currentId = 'wm-panel-root';
    }

    function init() {
      var drawer = document.getElementById('dynamic-menu-drawer');
      if (!drawer) return;
      backBtn = drawer.querySelector('.wm-nav__back');
      backLabel = drawer.querySelector('.wm-nav__back-label');
      if (!backBtn) return;

      // Forward navigation
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('#dynamic-menu-drawer [data-target]');
        if (btn) navigate(btn.dataset.target, false);
      });

      // Back button
      backBtn.addEventListener('click', function () {
        var panel = getPanel(currentId);
        var parentId = (panel && panel.dataset.parent) || 'wm-panel-root';
        navigate(parentId, true);
      });

      // Reset on drawer close
      drawer.addEventListener('close', function () {
        setTimeout(resetToRoot, 320);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
